"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ArticleJsonLd: () => article_default,
  BrandJsonLd: () => brand_default,
  BreadcrumbJsonLd: () => breadcrumb_default,
  CarouselJsonLd: () => carousel_default,
  CollectionPageJsonLd: () => collectionPage_default,
  CorporateContactJsonLd: () => corporateContact_default,
  CourseJsonLd: () => course_default,
  DatasetJsonLd: () => dataset_default,
  DefaultSeo: () => DefaultSeo,
  EventJsonLd: () => event_default,
  FAQPageJsonLd: () => faqPage_default,
  HowToJsonLd: () => howTo_default,
  JobPostingJsonLd: () => jobPosting_default,
  LocalBusinessJsonLd: () => localBusiness_default,
  LogoJsonLd: () => logo_default,
  NewsArticleJsonLd: () => newsarticle_default,
  NextSeo: () => NextSeo,
  OrganizationJsonLd: () => organization_default,
  ProductJsonLd: () => product_default,
  ProfilePageJsonLd: () => profilePage_default,
  QAPageJsonLd: () => qaPage_default,
  RecipeJsonLd: () => recipe_default,
  SiteLinksSearchBoxJsonLd: () => siteLinksSearchBox_default,
  SocialProfileJsonLd: () => socialProfile_default,
  SoftwareAppJsonLd: () => softwareApp_default,
  VideoGameJsonLd: () => videoGame_default,
  VideoJsonLd: () => video_default,
  WebPageJsonLd: () => webPage_default
});
module.exports = __toCommonJS(src_exports);

// src/meta/defaultSEO.tsx
var import_head = __toESM(require("next/head"));
var import_react2 = __toESM(require("react"));

// src/meta/buildTags.tsx
var import_react = __toESM(require("react"));
var defaults = {
  templateTitle: "",
  noindex: false,
  nofollow: false,
  defaultOpenGraphImageWidth: 0,
  defaultOpenGraphImageHeight: 0,
  defaultOpenGraphVideoWidth: 0,
  defaultOpenGraphVideoHeight: 0
};
var buildOpenGraphMediaTags = (mediaType, media = [], {
  defaultWidth,
  defaultHeight
} = {}) => {
  return media.reduce((tags, medium, index) => {
    tags.push(
      /* @__PURE__ */ import_react.default.createElement("meta", {
        key: `og:${mediaType}:0${index}`,
        property: `og:${mediaType}`,
        content: medium.url
      })
    );
    if (medium.alt) {
      tags.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `og:${mediaType}:alt0${index}`,
          property: `og:${mediaType}:alt`,
          content: medium.alt
        })
      );
    }
    if (medium.secureUrl) {
      tags.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `og:${mediaType}:secure_url0${index}`,
          property: `og:${mediaType}:secure_url`,
          content: medium.secureUrl.toString()
        })
      );
    }
    if (medium.type) {
      tags.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `og:${mediaType}:type0${index}`,
          property: `og:${mediaType}:type`,
          content: medium.type.toString()
        })
      );
    }
    if (medium.width) {
      tags.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `og:${mediaType}:width0${index}`,
          property: `og:${mediaType}:width`,
          content: medium.width.toString()
        })
      );
    } else if (defaultWidth) {
      tags.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `og:${mediaType}:width0${index}`,
          property: `og:${mediaType}:width`,
          content: defaultWidth.toString()
        })
      );
    }
    if (medium.height) {
      tags.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `og:${mediaType}:height${index}`,
          property: `og:${mediaType}:height`,
          content: medium.height.toString()
        })
      );
    } else if (defaultHeight) {
      tags.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `og:${mediaType}:height${index}`,
          property: `og:${mediaType}:height`,
          content: defaultHeight.toString()
        })
      );
    }
    return tags;
  }, []);
};
var buildTags = (config) => {
  var _a, _b, _c, _d, _e;
  const tagsToRender = [];
  if (config.titleTemplate) {
    defaults.templateTitle = config.titleTemplate;
  }
  let updatedTitle = "";
  if (config.title) {
    updatedTitle = config.title;
    if (defaults.templateTitle) {
      updatedTitle = defaults.templateTitle.replace(/%s/g, () => updatedTitle);
    }
  } else if (config.defaultTitle) {
    updatedTitle = config.defaultTitle;
  }
  if (updatedTitle) {
    tagsToRender.push(/* @__PURE__ */ import_react.default.createElement("title", {
      key: "title"
    }, updatedTitle));
  }
  const noindex = config.noindex || defaults.noindex || config.dangerouslySetAllPagesToNoIndex;
  const nofollow = config.nofollow || defaults.nofollow || config.dangerouslySetAllPagesToNoFollow;
  let robotsParams = "";
  if (config.robotsProps) {
    const {
      nosnippet,
      maxSnippet,
      maxImagePreview,
      maxVideoPreview,
      noarchive,
      noimageindex,
      notranslate,
      unavailableAfter
    } = config.robotsProps;
    robotsParams = `${nosnippet ? ",nosnippet" : ""}${maxSnippet ? `,max-snippet:${maxSnippet}` : ""}${maxImagePreview ? `,max-image-preview:${maxImagePreview}` : ""}${noarchive ? ",noarchive" : ""}${unavailableAfter ? `,unavailable_after:${unavailableAfter}` : ""}${noimageindex ? ",noimageindex" : ""}${maxVideoPreview ? `,max-video-preview:${maxVideoPreview}` : ""}${notranslate ? ",notranslate" : ""}`;
  }
  if (noindex || nofollow) {
    if (config.dangerouslySetAllPagesToNoIndex) {
      defaults.noindex = true;
    }
    if (config.dangerouslySetAllPagesToNoFollow) {
      defaults.nofollow = true;
    }
    tagsToRender.push(
      /* @__PURE__ */ import_react.default.createElement("meta", {
        key: "robots",
        name: "robots",
        content: `${noindex ? "noindex" : "index"},${nofollow ? "nofollow" : "follow"}${robotsParams}`
      })
    );
  } else {
    tagsToRender.push(
      /* @__PURE__ */ import_react.default.createElement("meta", {
        key: "robots",
        name: "robots",
        content: `index,follow${robotsParams}`
      })
    );
  }
  if (config.description) {
    tagsToRender.push(
      /* @__PURE__ */ import_react.default.createElement("meta", {
        key: "description",
        name: "description",
        content: config.description
      })
    );
  }
  if (config.mobileAlternate) {
    tagsToRender.push(
      /* @__PURE__ */ import_react.default.createElement("link", {
        rel: "alternate",
        key: "mobileAlternate",
        media: config.mobileAlternate.media,
        href: config.mobileAlternate.href
      })
    );
  }
  if (config.languageAlternates && config.languageAlternates.length > 0) {
    config.languageAlternates.forEach((languageAlternate) => {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("link", {
          rel: "alternate",
          key: `languageAlternate-${languageAlternate.hrefLang}`,
          hrefLang: languageAlternate.hrefLang,
          href: languageAlternate.href
        })
      );
    });
  }
  if (config.twitter) {
    if (config.twitter.cardType) {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "twitter:card",
          name: "twitter:card",
          content: config.twitter.cardType
        })
      );
    }
    if (config.twitter.site) {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "twitter:site",
          name: "twitter:site",
          content: config.twitter.site
        })
      );
    }
    if (config.twitter.handle) {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "twitter:creator",
          name: "twitter:creator",
          content: config.twitter.handle
        })
      );
    }
  }
  if (config.facebook) {
    if (config.facebook.appId) {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "fb:app_id",
          property: "fb:app_id",
          content: config.facebook.appId
        })
      );
    }
  }
  if (((_a = config.openGraph) == null ? void 0 : _a.title) || updatedTitle) {
    tagsToRender.push(
      /* @__PURE__ */ import_react.default.createElement("meta", {
        key: "og:title",
        property: "og:title",
        content: ((_b = config.openGraph) == null ? void 0 : _b.title) || updatedTitle
      })
    );
  }
  if (((_c = config.openGraph) == null ? void 0 : _c.description) || config.description) {
    tagsToRender.push(
      /* @__PURE__ */ import_react.default.createElement("meta", {
        key: "og:description",
        property: "og:description",
        content: ((_d = config.openGraph) == null ? void 0 : _d.description) || config.description
      })
    );
  }
  if (config.openGraph) {
    if (config.openGraph.url || config.canonical) {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "og:url",
          property: "og:url",
          content: config.openGraph.url || config.canonical
        })
      );
    }
    if (config.openGraph.type) {
      const type = config.openGraph.type.toLowerCase();
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "og:type",
          property: "og:type",
          content: type
        })
      );
      if (type === "profile" && config.openGraph.profile) {
        if (config.openGraph.profile.firstName) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "profile:first_name",
              property: "profile:first_name",
              content: config.openGraph.profile.firstName
            })
          );
        }
        if (config.openGraph.profile.lastName) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "profile:last_name",
              property: "profile:last_name",
              content: config.openGraph.profile.lastName
            })
          );
        }
        if (config.openGraph.profile.username) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "profile:username",
              property: "profile:username",
              content: config.openGraph.profile.username
            })
          );
        }
        if (config.openGraph.profile.gender) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "profile:gender",
              property: "profile:gender",
              content: config.openGraph.profile.gender
            })
          );
        }
      } else if (type === "book" && config.openGraph.book) {
        if (config.openGraph.book.authors && config.openGraph.book.authors.length) {
          config.openGraph.book.authors.forEach((author, index) => {
            tagsToRender.push(
              /* @__PURE__ */ import_react.default.createElement("meta", {
                key: `book:author:0${index}`,
                property: "book:author",
                content: author
              })
            );
          });
        }
        if (config.openGraph.book.isbn) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "book:isbn",
              property: "book:isbn",
              content: config.openGraph.book.isbn
            })
          );
        }
        if (config.openGraph.book.releaseDate) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "book:release_date",
              property: "book:release_date",
              content: config.openGraph.book.releaseDate
            })
          );
        }
        if (config.openGraph.book.tags && config.openGraph.book.tags.length) {
          config.openGraph.book.tags.forEach((tag, index) => {
            tagsToRender.push(
              /* @__PURE__ */ import_react.default.createElement("meta", {
                key: `book:tag:0${index}`,
                property: "book:tag",
                content: tag
              })
            );
          });
        }
      } else if (type === "article" && config.openGraph.article) {
        if (config.openGraph.article.publishedTime) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "article:published_time",
              property: "article:published_time",
              content: config.openGraph.article.publishedTime
            })
          );
        }
        if (config.openGraph.article.modifiedTime) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "article:modified_time",
              property: "article:modified_time",
              content: config.openGraph.article.modifiedTime
            })
          );
        }
        if (config.openGraph.article.expirationTime) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "article:expiration_time",
              property: "article:expiration_time",
              content: config.openGraph.article.expirationTime
            })
          );
        }
        if (config.openGraph.article.authors && config.openGraph.article.authors.length) {
          config.openGraph.article.authors.forEach((author, index) => {
            tagsToRender.push(
              /* @__PURE__ */ import_react.default.createElement("meta", {
                key: `article:author:0${index}`,
                property: "article:author",
                content: author
              })
            );
          });
        }
        if (config.openGraph.article.section) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "article:section",
              property: "article:section",
              content: config.openGraph.article.section
            })
          );
        }
        if (config.openGraph.article.tags && config.openGraph.article.tags.length) {
          config.openGraph.article.tags.forEach((tag, index) => {
            tagsToRender.push(
              /* @__PURE__ */ import_react.default.createElement("meta", {
                key: `article:tag:0${index}`,
                property: "article:tag",
                content: tag
              })
            );
          });
        }
      } else if ((type === "video.movie" || type === "video.episode" || type === "video.tv_show" || type === "video.other") && config.openGraph.video) {
        if (config.openGraph.video.actors && config.openGraph.video.actors.length) {
          config.openGraph.video.actors.forEach((actor, index) => {
            if (actor.profile) {
              tagsToRender.push(
                /* @__PURE__ */ import_react.default.createElement("meta", {
                  key: `video:actor:0${index}`,
                  property: "video:actor",
                  content: actor.profile
                })
              );
            }
            if (actor.role) {
              tagsToRender.push(
                /* @__PURE__ */ import_react.default.createElement("meta", {
                  key: `video:actor:role:0${index}`,
                  property: "video:actor:role",
                  content: actor.role
                })
              );
            }
          });
        }
        if (config.openGraph.video.directors && config.openGraph.video.directors.length) {
          config.openGraph.video.directors.forEach((director, index) => {
            tagsToRender.push(
              /* @__PURE__ */ import_react.default.createElement("meta", {
                key: `video:director:0${index}`,
                property: "video:director",
                content: director
              })
            );
          });
        }
        if (config.openGraph.video.writers && config.openGraph.video.writers.length) {
          config.openGraph.video.writers.forEach((writer, index) => {
            tagsToRender.push(
              /* @__PURE__ */ import_react.default.createElement("meta", {
                key: `video:writer:0${index}`,
                property: "video:writer",
                content: writer
              })
            );
          });
        }
        if (config.openGraph.video.duration) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "video:duration",
              property: "video:duration",
              content: config.openGraph.video.duration.toString()
            })
          );
        }
        if (config.openGraph.video.releaseDate) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "video:release_date",
              property: "video:release_date",
              content: config.openGraph.video.releaseDate
            })
          );
        }
        if (config.openGraph.video.tags && config.openGraph.video.tags.length) {
          config.openGraph.video.tags.forEach((tag, index) => {
            tagsToRender.push(
              /* @__PURE__ */ import_react.default.createElement("meta", {
                key: `video:tag:0${index}`,
                property: "video:tag",
                content: tag
              })
            );
          });
        }
        if (config.openGraph.video.series) {
          tagsToRender.push(
            /* @__PURE__ */ import_react.default.createElement("meta", {
              key: "video:series",
              property: "video:series",
              content: config.openGraph.video.series
            })
          );
        }
      }
    }
    if (config.defaultOpenGraphImageWidth) {
      defaults.defaultOpenGraphImageWidth = config.defaultOpenGraphImageWidth;
    }
    if (config.defaultOpenGraphImageHeight) {
      defaults.defaultOpenGraphImageHeight = config.defaultOpenGraphImageHeight;
    }
    if (config.openGraph.images && config.openGraph.images.length) {
      tagsToRender.push(
        ...buildOpenGraphMediaTags("image", config.openGraph.images, {
          defaultWidth: defaults.defaultOpenGraphImageWidth,
          defaultHeight: defaults.defaultOpenGraphImageHeight
        })
      );
    }
    if (config.defaultOpenGraphVideoWidth) {
      defaults.defaultOpenGraphVideoWidth = config.defaultOpenGraphVideoWidth;
    }
    if (config.defaultOpenGraphVideoHeight) {
      defaults.defaultOpenGraphVideoHeight = config.defaultOpenGraphVideoHeight;
    }
    if (config.openGraph.videos && config.openGraph.videos.length) {
      tagsToRender.push(
        ...buildOpenGraphMediaTags("video", config.openGraph.videos, {
          defaultWidth: defaults.defaultOpenGraphVideoWidth,
          defaultHeight: defaults.defaultOpenGraphVideoHeight
        })
      );
    }
    if (config.openGraph.locale) {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "og:locale",
          property: "og:locale",
          content: config.openGraph.locale
        })
      );
    }
    if (config.openGraph.site_name) {
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: "og:site_name",
          property: "og:site_name",
          content: config.openGraph.site_name
        })
      );
    }
  }
  if (config.canonical) {
    tagsToRender.push(
      /* @__PURE__ */ import_react.default.createElement("link", {
        rel: "canonical",
        href: config.canonical,
        key: "canonical"
      })
    );
  }
  if (config.additionalMetaTags && config.additionalMetaTags.length > 0) {
    config.additionalMetaTags.forEach((tag) => {
      var _a2, _b2, _c2;
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("meta", {
          key: `meta:${(_c2 = (_b2 = (_a2 = tag.keyOverride) != null ? _a2 : tag.name) != null ? _b2 : tag.property) != null ? _c2 : tag.httpEquiv}`,
          ...tag
        })
      );
    });
  }
  if ((_e = config.additionalLinkTags) == null ? void 0 : _e.length) {
    config.additionalLinkTags.forEach((tag) => {
      var _a2;
      tagsToRender.push(
        /* @__PURE__ */ import_react.default.createElement("link", {
          key: `link${(_a2 = tag.keyOverride) != null ? _a2 : tag.href}${tag.rel}`,
          ...tag
        })
      );
    });
  }
  return tagsToRender;
};
var buildTags_default = buildTags;

// src/meta/defaultSEO.tsx
var DefaultSeo = class extends import_react2.Component {
  render() {
    const {
      title,
      titleTemplate,
      defaultTitle,
      dangerouslySetAllPagesToNoIndex = false,
      dangerouslySetAllPagesToNoFollow = false,
      description,
      canonical,
      facebook,
      openGraph,
      additionalMetaTags,
      twitter,
      defaultOpenGraphImageWidth,
      defaultOpenGraphImageHeight,
      defaultOpenGraphVideoWidth,
      defaultOpenGraphVideoHeight,
      mobileAlternate,
      languageAlternates,
      additionalLinkTags,
      robotsProps
    } = this.props;
    return /* @__PURE__ */ import_react2.default.createElement(import_head.default, null, buildTags_default({
      title,
      titleTemplate,
      defaultTitle,
      dangerouslySetAllPagesToNoIndex,
      dangerouslySetAllPagesToNoFollow,
      description,
      canonical,
      facebook,
      openGraph,
      additionalMetaTags,
      twitter,
      defaultOpenGraphImageWidth,
      defaultOpenGraphImageHeight,
      defaultOpenGraphVideoWidth,
      defaultOpenGraphVideoHeight,
      mobileAlternate,
      languageAlternates,
      additionalLinkTags,
      robotsProps
    }));
  }
};

// src/meta/nextSEO.tsx
var import_head2 = __toESM(require("next/head"));
var import_react3 = __toESM(require("react"));
var NextSeo = class extends import_react3.Component {
  render() {
    const {
      title,
      noindex = false,
      nofollow,
      robotsProps,
      description,
      canonical,
      openGraph,
      facebook,
      twitter,
      additionalMetaTags,
      titleTemplate,
      mobileAlternate,
      languageAlternates,
      additionalLinkTags
    } = this.props;
    return /* @__PURE__ */ import_react3.default.createElement(import_head2.default, null, buildTags_default({
      title,
      noindex,
      nofollow,
      robotsProps,
      description,
      canonical,
      facebook,
      openGraph,
      additionalMetaTags,
      twitter,
      titleTemplate,
      mobileAlternate,
      languageAlternates,
      additionalLinkTags
    }));
  }
};

// src/jsonld/carousel.tsx
var import_react5 = __toESM(require("react"));

// src/jsonld/jsonld.tsx
var import_react4 = __toESM(require("react"));
var import_head3 = __toESM(require("next/head"));

// src/utils/toJson.tsx
var toJson = (type, jsonld) => {
  const { id = void 0 } = jsonld;
  const updated = {
    ...id ? { "@id": jsonld.id } : {},
    ...jsonld
  };
  delete updated.id;
  return {
    __html: JSON.stringify(
      {
        "@context": "https://schema.org",
        "@type": type,
        ...updated
      },
      safeJsonLdReplacer
    )
  };
};
var ESCAPE_ENTITIES = Object.freeze({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&apos;"
});
var ESCAPE_REGEX = new RegExp(
  `[${Object.keys(ESCAPE_ENTITIES).join("")}]`,
  "g"
);
var ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
var safeJsonLdReplacer = (() => {
  return (_, value) => {
    switch (typeof value) {
      case "object":
        if (value === null) {
          return void 0;
        }
        return value;
      case "number":
      case "boolean":
      case "bigint":
        return value;
      case "string":
        return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
      default: {
        isNever(value);
        return void 0;
      }
    }
  };
})();
function isNever(_) {
}
var toJson_default = toJson;

// src/jsonld/jsonld.tsx
function JsonLd({
  type = "Thing",
  keyOverride,
  scriptKey,
  scriptId = void 0,
  ...rest
}) {
  return /* @__PURE__ */ import_react4.default.createElement(import_head3.default, null, /* @__PURE__ */ import_react4.default.createElement("script", {
    type: "application/ld+json",
    id: scriptId,
    dangerouslySetInnerHTML: toJson_default(type, { ...rest }),
    key: `jsonld-${scriptKey}${keyOverride ? `-${keyOverride}` : ""}`
  }));
}

// src/utils/schema/setAuthor.ts
function includeNameAndUrl(author) {
  return typeof author === "object" && !!(author.name && author.url);
}
function generateAuthorInfo(author) {
  if (typeof author === "string") {
    return {
      "@type": "Person",
      name: author
    };
  } else if (includeNameAndUrl(author)) {
    return {
      "@type": "Person",
      name: author.name,
      url: author.url
    };
  }
  return;
}
function setAuthor(author) {
  if (Array.isArray(author)) {
    return author.map((item) => generateAuthorInfo(item)).filter((item) => !!item);
  } else if (author) {
    return generateAuthorInfo(author);
  }
  return;
}

// src/utils/schema/setImage.ts
function setImage(image) {
  if (image) {
    return { "@type": "ImageObject", url: image };
  }
  return void 0;
}

// src/utils/schema/setPublisher.ts
function setPublisher(publisherName, publisherLogo) {
  if (!publisherName) {
    return void 0;
  }
  return {
    "@type": "Organization",
    name: publisherName,
    logo: setImage(publisherLogo)
  };
}

// src/utils/schema/setReviewRating.ts
function setReviewRating(rating) {
  if (rating) {
    return { ...rating, "@type": "Rating" };
  }
  return void 0;
}

// src/utils/schema/setReviews.ts
function setReviews(reviews) {
  function mapReview({ reviewRating, author, publisher, ...rest }) {
    return {
      ...rest,
      "@type": "Review",
      ...author && { author: setAuthor(author) },
      ...reviewRating && { reviewRating: setReviewRating(reviewRating) },
      ...publisher && { publisher: setPublisher(publisher.name) }
    };
  }
  if (Array.isArray(reviews)) {
    return reviews.map(mapReview);
  } else if (reviews) {
    return mapReview(reviews);
  }
  return void 0;
}

// src/utils/schema/setNutrition.ts
function setNutrition(calories) {
  if (calories) {
    return {
      "@type": "NutritionInformation",
      calories: `${calories} calories`
    };
  }
  return void 0;
}

// src/utils/schema/setAggregateRating.ts
function setAggregateRating(aggregateRating) {
  if (aggregateRating) {
    return {
      "@type": "AggregateRating",
      ratingCount: aggregateRating.ratingCount,
      reviewCount: aggregateRating.reviewCount,
      bestRating: aggregateRating.bestRating,
      ratingValue: aggregateRating.ratingValue
    };
  }
  return void 0;
}

// src/utils/schema/setClip.ts
function setClip(clips) {
  function mapClip(clip) {
    return {
      ...clip,
      "@type": "Clip"
    };
  }
  if (Array.isArray(clips)) {
    return clips.map(mapClip);
  } else if (clips) {
    return mapClip(clips);
  }
  return void 0;
}

// src/utils/schema/setInteractionStatistic.ts
function setInteractionStatistic(watchCount) {
  if (watchCount) {
    return {
      "@type": "InteractionCounter",
      interactionType: "https://schema.org/WatchAction",
      userInteractionCount: watchCount
    };
  }
  return void 0;
}

// src/utils/schema/setBroadcastEvent.ts
function setBroadcastEvent(publication) {
  function mapBroadcastEvent(publication2) {
    return {
      ...publication2,
      "@type": "BroadcastEvent"
    };
  }
  if (publication) {
    if (Array.isArray(publication)) {
      return publication.map(mapBroadcastEvent);
    }
    return mapBroadcastEvent(publication);
  }
  return void 0;
}

// src/utils/schema/setVideo.ts
function setVideo(video, setContext = false) {
  function mapVideo({ thumbnailUrls, hasPart, watchCount, publication, ...rest }, context) {
    return {
      ...rest,
      "@type": "VideoObject",
      ...context && { "@context": "https://schema.org" },
      thumbnailUrl: thumbnailUrls,
      hasPart: setClip(hasPart),
      interactionStatistic: setInteractionStatistic(watchCount),
      publication: setBroadcastEvent(publication)
    };
  }
  if (video) {
    return mapVideo(video, setContext);
  }
  return void 0;
}

// src/utils/schema/setInstruction.ts
function setInstruction(instruction) {
  if (instruction) {
    return {
      ...instruction,
      "@type": "HowToStep"
    };
  }
  return void 0;
}

// src/jsonld/carousel.tsx
function CarouselJsonLd({
  type = "Carousel",
  keyOverride,
  ofType,
  data
}) {
  function generateList(data2, ofType2) {
    switch (ofType2) {
      case "default":
        return data2.map((item, index) => ({
          "@type": "ListItem",
          position: `${index + 1}`,
          url: item.url
        }));
      case "course":
        return data2.map((item, index) => ({
          "@type": "ListItem",
          position: `${index + 1}`,
          item: {
            "@context": "https://schema.org",
            "@type": "Course",
            url: item.url,
            name: item.courseName,
            description: item.description,
            provider: {
              "@type": "Organization",
              name: item.providerName,
              sameAs: item.providerUrl
            }
          }
        }));
      case "movie":
        return data2.map((item, index) => ({
          "@type": "ListItem",
          position: `${index + 1}`,
          item: {
            "@context": "https://schema.org",
            "@type": "Movie",
            name: item.name,
            url: item.url,
            image: item.image,
            dateCreated: item.dateCreated,
            director: item.director ? Array.isArray(item.director) ? item.director.map((director) => ({
              "@type": "Person",
              name: director.name
            })) : {
              "@type": "Person",
              name: item.director.name
            } : void 0,
            review: setReviews(item.review)
          }
        }));
      case "recipe":
        return data2.map(
          ({
            authorName,
            images,
            yields,
            category,
            calories,
            aggregateRating,
            video,
            ingredients,
            instructions,
            cuisine,
            ...rest
          }, index) => ({
            "@type": "ListItem",
            position: `${index + 1}`,
            item: {
              "@context": "https://schema.org",
              "@type": "Recipe",
              ...rest,
              author: setAuthor(authorName),
              image: images,
              recipeYield: yields,
              recipeCategory: category,
              recipeCuisine: cuisine,
              nutrition: setNutrition(calories),
              aggregateRating: setAggregateRating(aggregateRating),
              video: setVideo(video),
              recipeIngredient: ingredients,
              recipeInstructions: instructions.map(setInstruction)
            }
          })
        );
    }
  }
  const d = {
    "@type": "ItemList",
    itemListElement: generateList(data, ofType)
  };
  return /* @__PURE__ */ import_react5.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...d,
    scriptKey: "Carousel"
  });
}
var carousel_default = CarouselJsonLd;

// src/jsonld/newsarticle.tsx
var import_react6 = __toESM(require("react"));
function NewsArticleJsonLd({
  type = "NewsArticle",
  keyOverride,
  url,
  title,
  images,
  section,
  dateCreated,
  datePublished,
  dateModified,
  authorName,
  publisherName,
  publisherLogo,
  body,
  ...rest
}) {
  const data = {
    ...rest,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url
    },
    headline: title,
    image: images,
    articleSection: section,
    dateCreated: dateCreated || datePublished,
    datePublished,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    articleBody: body
  };
  return /* @__PURE__ */ import_react6.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "NewsArticle"
  });
}
var newsarticle_default = NewsArticleJsonLd;

// src/jsonld/jobPosting.tsx
var import_react7 = __toESM(require("react"));
function JobPostingJsonLd({
  type = "JobPosting",
  keyOverride,
  baseSalary,
  hiringOrganization,
  applicantLocationRequirements,
  jobLocation,
  ...rest
}) {
  function setBaseSalary(baseSalary2) {
    if (baseSalary2) {
      return {
        "@type": "MonetaryAmount",
        currency: baseSalary2.currency,
        value: {
          "@type": "QuantitativeValue",
          unitText: baseSalary2.unitText,
          ...Array.isArray(baseSalary2.value) ? {
            minValue: baseSalary2.value[0],
            maxValue: baseSalary2.value[1]
          } : { value: baseSalary2.value }
        }
      };
    }
    return void 0;
  }
  function setHiringOrganization(org) {
    return {
      "@type": "Organization",
      name: org.name,
      sameAs: org.sameAs,
      logo: org.logo
    };
  }
  function setJobLocation(location) {
    if (location) {
      return {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          addressCountry: location.addressCountry,
          addressLocality: location.addressLocality,
          addressRegion: location.addressRegion,
          postalCode: location.postalCode,
          streetAddress: location.streetAddress
        }
      };
    }
    return void 0;
  }
  function setApplicantLocationRequirements(requirements) {
    if (requirements) {
      return {
        "@type": "Country",
        name: requirements
      };
    }
    return void 0;
  }
  const data = {
    ...rest,
    baseSalary: setBaseSalary(baseSalary),
    hiringOrganization: setHiringOrganization(hiringOrganization),
    jobLocation: setJobLocation(jobLocation),
    applicantLocationRequirements: setApplicantLocationRequirements(
      applicantLocationRequirements
    )
  };
  return /* @__PURE__ */ import_react7.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "JobPosting"
  });
}
var jobPosting_default = JobPostingJsonLd;

// src/jsonld/localBusiness.tsx
var import_react8 = __toESM(require("react"));

// src/utils/schema/setAddress.ts
function setAddress(address) {
  if (address) {
    return {
      "@type": "PostalAddress",
      ...address
    };
  }
  return void 0;
}

// src/utils/schema/setGeo.ts
function setGeo(geo) {
  if (geo) {
    return {
      ...geo,
      "@type": "GeoCoordinates"
    };
  }
  return void 0;
}

// src/utils/schema/setAction.ts
function setAction(action) {
  if (action) {
    return {
      "@type": action.actionType,
      name: action.actionName,
      target: action.target
    };
  }
  return void 0;
}

// src/utils/schema/setGeoCircle.ts
function setGeoCircle(geoCircle) {
  if (geoCircle) {
    return {
      "@type": "GeoCircle",
      geoMidpoint: {
        "@type": "GeoCoordinates",
        latitude: geoCircle.geoMidpoint.latitude,
        longitude: geoCircle.geoMidpoint.longitude
      },
      geoRadius: geoCircle.geoRadius
    };
  }
  return void 0;
}

// src/utils/schema/setOffer.ts
function setOffer(offer) {
  function setPriceSpecification(priceSpecification) {
    if (priceSpecification) {
      return {
        "@type": priceSpecification.type,
        priceCurrency: priceSpecification.priceCurrency,
        price: priceSpecification.price
      };
    }
    return void 0;
  }
  function setItemOffered(itemOffered) {
    if (itemOffered) {
      return {
        ...itemOffered,
        "@type": "Service"
      };
    }
    return void 0;
  }
  if (offer) {
    return {
      ...offer,
      "@type": "Offer",
      priceSpecification: setPriceSpecification(offer.priceSpecification),
      itemOffered: setItemOffered(offer.itemOffered)
    };
  }
  return void 0;
}

// src/utils/schema/setOpeningHours.ts
function setOpeningHours(openingHours) {
  if (openingHours) {
    return {
      ...openingHours,
      "@type": "OpeningHoursSpecification"
    };
  }
  return void 0;
}

// src/jsonld/localBusiness.tsx
function LocalBusinessJsonLd({
  type = "LocalBusiness",
  keyOverride,
  address,
  geo,
  rating,
  review,
  action,
  areaServed,
  makesOffer,
  openingHours,
  images,
  ...rest
}) {
  const data = {
    ...rest,
    image: images,
    address: setAddress(address),
    geo: setGeo(geo),
    aggregateRating: setAggregateRating(rating),
    review: setReviews(review),
    potentialAction: setAction(action),
    areaServed: areaServed && areaServed.map(setGeoCircle),
    makesOffer: makesOffer == null ? void 0 : makesOffer.map(setOffer),
    openingHoursSpecification: Array.isArray(openingHours) ? openingHours.map(setOpeningHours) : setOpeningHours(openingHours)
  };
  return /* @__PURE__ */ import_react8.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "LocalBusiness"
  });
}
var localBusiness_default = LocalBusinessJsonLd;

// src/jsonld/qaPage.tsx
var import_react9 = __toESM(require("react"));
function QAPageJsonLd({
  type = "QAPage",
  keyOverride,
  mainEntity,
  ...rest
}) {
  var _a, _b, _c;
  const data = {
    ...rest,
    mainEntity: {
      ...mainEntity,
      "@type": "Question",
      author: setAuthor((_a = mainEntity.author) == null ? void 0 : _a.name),
      ...mainEntity.acceptedAnswer && {
        acceptedAnswer: {
          ...mainEntity.acceptedAnswer,
          "@type": "Answer",
          author: setAuthor((_c = (_b = mainEntity.acceptedAnswer) == null ? void 0 : _b.author) == null ? void 0 : _c.name)
        }
      },
      ...mainEntity.suggestedAnswer && {
        suggestedAnswer: mainEntity.suggestedAnswer.map(
          ({ upvoteCount, ...rest2 }) => {
            var _a2;
            return {
              ...rest2,
              "@type": "Answer",
              upvoteCount: upvoteCount || 0,
              author: setAuthor((_a2 = rest2.author) == null ? void 0 : _a2.name)
            };
          }
        )
      }
    }
  };
  return /* @__PURE__ */ import_react9.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "QAPage"
  });
}
var qaPage_default = QAPageJsonLd;

// src/jsonld/profilePage.tsx
var import_react10 = __toESM(require("react"));

// src/utils/schema/setItemListElements.ts
function setItemListElements(items) {
  if (items && items.length) {
    return items.map((item) => ({
      "@type": "ListItem",
      position: item.position,
      item: {
        "@id": item.item,
        name: item.name
      }
    }));
  }
  return void 0;
}

// src/jsonld/profilePage.tsx
function ProfilePageJsonLd({
  type = "ProfilePage",
  keyOverride,
  breadcrumb,
  ...rest
}) {
  const data = {
    ...rest,
    breadcrumb: Array.isArray(breadcrumb) ? {
      "@type": "BreadcrumbList",
      itemListElement: setItemListElements(breadcrumb)
    } : breadcrumb
  };
  return /* @__PURE__ */ import_react10.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "ProfilePage"
  });
}
var profilePage_default = ProfilePageJsonLd;

// src/jsonld/siteLinksSearchBox.tsx
var import_react11 = __toESM(require("react"));
function SiteLinksSearchBoxJsonLd({
  type = "WebSite",
  keyOverride,
  potentialActions,
  ...rest
}) {
  function setPotentialAction(action) {
    if (action) {
      const { target, queryInput } = action;
      return {
        "@type": "SearchAction",
        target: `${target}={${queryInput}}`,
        "query-input": `required name=${queryInput}`
      };
    }
    return void 0;
  }
  const data = {
    ...rest,
    potentialAction: potentialActions.map(setPotentialAction)
  };
  return /* @__PURE__ */ import_react11.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "jsonld-siteLinksSearchBox"
  });
}
var siteLinksSearchBox_default = SiteLinksSearchBoxJsonLd;

// src/jsonld/recipe.tsx
var import_react12 = __toESM(require("react"));
function RecipeJsonLd({
  type = "Recipe",
  keyOverride,
  authorName,
  images,
  yields,
  category,
  cuisine,
  calories,
  aggregateRating,
  video,
  ingredients,
  instructions,
  ...rest
}) {
  const data = {
    ...rest,
    author: setAuthor(authorName),
    image: images,
    recipeYield: yields,
    recipeCategory: category,
    recipeCuisine: cuisine,
    nutrition: setNutrition(calories),
    aggregateRating: setAggregateRating(aggregateRating),
    video: setVideo(video),
    recipeIngredient: ingredients,
    recipeInstructions: instructions.map(setInstruction)
  };
  return /* @__PURE__ */ import_react12.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "recipe"
  });
}
var recipe_default = RecipeJsonLd;

// src/jsonld/event.tsx
var import_react13 = __toESM(require("react"));

// src/utils/schema/setLocation.ts
function setLocation(location) {
  if (!location) {
    return void 0;
  }
  if ("url" in location) {
    return setVirtualLocation(location);
  } else {
    return setPlace(location);
  }
}
function setVirtualLocation(location) {
  return {
    ...location,
    "@type": "VirtualLocation"
  };
}
function setPlace(location) {
  return {
    ...location,
    address: setAddress(location.address),
    "@type": "Place"
  };
}

// src/utils/schema/setPerformer.ts
function setPerformer(performer) {
  if (performer) {
    const { type, ...restPerformer } = performer;
    return {
      ...restPerformer,
      "@type": type || "PerformingGroup"
    };
  }
  return void 0;
}

// src/utils/schema/setOffers.ts
function setOffers(offers) {
  function mapOffer({ seller, ...rest }) {
    return {
      ...rest,
      "@type": "Offer",
      ...seller && {
        seller: {
          "@type": "Organization",
          name: seller.name
        }
      }
    };
  }
  if (Array.isArray(offers)) {
    return offers.map(mapOffer);
  } else if (offers) {
    return mapOffer(offers);
  }
  return void 0;
}

// src/utils/schema/setAggregateOffer.ts
function setAggregateOffer(aggregateOffer) {
  if (aggregateOffer) {
    return {
      "@type": "AggregateOffer",
      priceCurrency: aggregateOffer.priceCurrency,
      highPrice: aggregateOffer.highPrice,
      lowPrice: aggregateOffer.lowPrice,
      offerCount: aggregateOffer.offerCount,
      offers: setOffers(aggregateOffer.offers)
    };
  }
  return void 0;
}

// src/utils/schema/setOrganizer.ts
function setOrganizer(organizer) {
  if (organizer) {
    const { type, ...restOrganizer } = organizer;
    return {
      ...restOrganizer,
      "@type": type || "Person"
    };
  }
  return void 0;
}

// src/jsonld/event.tsx
function EventJsonLd({
  type = "Event",
  keyOverride,
  location,
  images,
  offers,
  aggregateOffer,
  performers,
  organizer,
  eventStatus,
  eventAttendanceMode,
  ...rest
}) {
  const data = {
    ...rest,
    location: setLocation(location),
    image: images,
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    performer: Array.isArray(performers) ? performers.map(setPerformer) : setPerformer(performers),
    organizer: Array.isArray(organizer) ? organizer.map(setOrganizer) : setOrganizer(organizer),
    eventStatus: `https://schema.org/${eventStatus}`,
    eventAttendanceMode: `https://schema.org/${eventAttendanceMode}`
  };
  return /* @__PURE__ */ import_react13.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "Event"
  });
}
var event_default = EventJsonLd;

// src/jsonld/corporateContact.tsx
var import_react14 = __toESM(require("react"));

// src/utils/schema/setContactPoint.ts
function setContactPoint(contactPoint) {
  if (contactPoint) {
    return {
      ...contactPoint,
      "@type": "ContactPoint"
    };
  }
  return void 0;
}

// src/jsonld/corporateContact.tsx
function CorporateContactJsonLd({
  type = "Organization",
  keyOverride,
  contactPoint,
  ...rest
}) {
  const data = {
    ...rest,
    contactPoint: contactPoint.map(setContactPoint)
  };
  return /* @__PURE__ */ import_react14.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "CorporateContact"
  });
}
var corporateContact_default = CorporateContactJsonLd;

// src/jsonld/collectionPage.tsx
var import_react15 = __toESM(require("react"));

// src/utils/schema/setCreativeWork.ts
function setCreativeWork(creativeWork) {
  if (creativeWork) {
    return {
      ...creativeWork,
      "@type": "CreativeWork"
    };
  }
  return void 0;
}

// src/jsonld/collectionPage.tsx
function CollectionPageJsonLd({
  type = "CollectionPage",
  keyOverride,
  hasPart,
  ...rest
}) {
  const data = {
    ...rest,
    hasPart: hasPart.map(setCreativeWork)
  };
  return /* @__PURE__ */ import_react15.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "CollectionPage"
  });
}
var collectionPage_default = CollectionPageJsonLd;

// src/jsonld/product.tsx
var import_react16 = __toESM(require("react"));

// src/utils/schema/setManufacturer.ts
function setManufacturer(manufacturer) {
  if (manufacturer && (manufacturer.manufacturerName || manufacturer.manufacturerLogo)) {
    return {
      "@type": "Organization",
      name: manufacturer.manufacturerName,
      logo: setImage(manufacturer.manufacturerLogo)
    };
  }
  return void 0;
}

// src/utils/schema/setBrand.ts
function setBrand(brand) {
  if (brand) {
    return {
      "@type": "Brand",
      name: brand
    };
  }
  return void 0;
}

// src/jsonld/product.tsx
function ProductJsonLd({
  type = "Product",
  keyOverride,
  images,
  brand,
  reviews,
  aggregateRating,
  manufacturerLogo,
  manufacturerName,
  offers,
  aggregateOffer,
  productName,
  ...rest
}) {
  const data = {
    ...rest,
    image: images,
    brand: setBrand(brand),
    review: setReviews(reviews),
    aggregateRating: setAggregateRating(aggregateRating),
    manufacturer: setManufacturer({ manufacturerLogo, manufacturerName }),
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    name: productName
  };
  return /* @__PURE__ */ import_react16.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "Product"
  });
}
var product_default = ProductJsonLd;

// src/jsonld/softwareApp.tsx
var import_react17 = __toESM(require("react"));
function SoftwareAppJsonLd({
  type = "SoftwareApplication",
  keyOverride,
  priceCurrency,
  price,
  aggregateRating,
  review,
  ...rest
}) {
  const data = {
    ...rest,
    offers: {
      "@type": "Offer",
      price,
      priceCurrency
    },
    aggregateRating: setAggregateRating(aggregateRating),
    review: setReviews(review)
  };
  return /* @__PURE__ */ import_react17.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "SoftwareApp"
  });
}
var softwareApp_default = SoftwareAppJsonLd;

// src/jsonld/video.tsx
var import_react18 = __toESM(require("react"));
function VideoJsonLd({ type = "Video", keyOverride, ...rest }) {
  const data = setVideo(rest, true);
  return /* @__PURE__ */ import_react18.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "Video"
  });
}
var video_default = VideoJsonLd;

// src/jsonld/videoGame.tsx
var import_react19 = __toESM(require("react"));

// src/utils/schema/setProducer.ts
function setProducer(producer) {
  if (producer) {
    return {
      "@type": "Organization",
      sameAs: producer.url,
      name: producer.name
    };
  }
  return void 0;
}

// src/utils/schema/setProvider.ts
function setProvider(provider) {
  if (provider) {
    return {
      "@type": provider.type || "Organization",
      name: provider.name,
      sameAs: provider.url
    };
  }
  return void 0;
}

// src/jsonld/videoGame.tsx
function VideoGameJsonLd({
  type = "VideoGame",
  keyOverride,
  aggregateRating,
  trailer,
  reviews,
  image,
  authorName,
  provider,
  producerName,
  producerUrl,
  offers,
  operatingSystemName,
  platformName,
  translatorName,
  languageName,
  genreName,
  publisherName,
  ...rest
}) {
  const data = {
    ...rest,
    aggregateRating: setAggregateRating(aggregateRating),
    trailer: setVideo(trailer),
    review: setReviews(reviews),
    image: setImage(image),
    author: setAuthor(authorName),
    provider: setProvider(provider),
    producer: setProducer({ name: producerName, url: producerUrl }),
    offers: setOffers(offers),
    operatingSystem: operatingSystemName,
    gamePlatform: platformName,
    translator: translatorName,
    inLanguage: languageName,
    genre: genreName,
    publisher: publisherName
  };
  return /* @__PURE__ */ import_react19.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "VideoGame"
  });
}
var videoGame_default = VideoGameJsonLd;

// src/jsonld/organization.tsx
var import_react20 = __toESM(require("react"));

// src/utils/schema/setContactPoints.ts
function setContactPoints(contactPoint) {
  if (contactPoint && contactPoint.length) {
    return contactPoint.map((contactPoint2) => ({
      "@type": "ContactPoint",
      ...contactPoint2
    }));
  }
  return void 0;
}

// src/jsonld/organization.tsx
function OrganizationJsonLd({
  type = "Organization",
  keyOverride,
  address,
  contactPoints,
  ...rest
}) {
  const data = {
    ...rest,
    address: setAddress(address),
    contactPoints: setContactPoints(contactPoints)
  };
  return /* @__PURE__ */ import_react20.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "organization"
  });
}
var organization_default = OrganizationJsonLd;

// src/jsonld/faqPage.tsx
var import_react21 = __toESM(require("react"));

// src/utils/schema/setQuestions.ts
function setQuestions(questions) {
  if (questions && questions.length) {
    return questions.map((question) => ({
      "@type": "Question",
      name: question.questionName,
      acceptedAnswer: {
        "@type": "Answer",
        text: question.acceptedAnswerText
      }
    }));
  }
  return void 0;
}

// src/jsonld/faqPage.tsx
function FAQPageJsonLd({
  type = "FAQPage",
  keyOverride,
  mainEntity,
  ...rest
}) {
  const data = {
    ...rest,
    mainEntity: setQuestions(mainEntity)
  };
  return /* @__PURE__ */ import_react21.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "faq-page"
  });
}
var faqPage_default = FAQPageJsonLd;

// src/jsonld/logo.tsx
var import_react22 = __toESM(require("react"));
function LogoJsonLd({
  type = "Organization",
  keyOverride,
  ...rest
}) {
  return /* @__PURE__ */ import_react22.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...rest,
    scriptKey: "Logo"
  });
}
var logo_default = LogoJsonLd;

// src/jsonld/dataset.tsx
var import_react23 = __toESM(require("react"));
function DatasetJsonLd({
  type = "Dataset",
  keyOverride,
  ...rest
}) {
  return /* @__PURE__ */ import_react23.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...rest,
    scriptKey: "dataset"
  });
}
var dataset_default = DatasetJsonLd;

// src/jsonld/course.tsx
var import_react24 = __toESM(require("react"));
function CourseJsonLd({
  type = "Course",
  keyOverride,
  courseName,
  provider,
  ...rest
}) {
  const data = {
    name: courseName,
    ...rest,
    provider: setProvider(provider)
  };
  return /* @__PURE__ */ import_react24.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "course"
  });
}
var course_default = CourseJsonLd;

// src/jsonld/breadcrumb.tsx
var import_react25 = __toESM(require("react"));
function BreadCrumbJsonLd({
  type = "BreadcrumbList",
  keyOverride,
  itemListElements
}) {
  const data = {
    itemListElement: setItemListElements(itemListElements)
  };
  return /* @__PURE__ */ import_react25.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "breadcrumb"
  });
}
var breadcrumb_default = BreadCrumbJsonLd;

// src/jsonld/brand.tsx
var import_react26 = __toESM(require("react"));
function BrandJsonLd({
  type = "Brand",
  id,
  keyOverride,
  aggregateRating,
  ...rest
}) {
  const data = {
    aggregateRating: setAggregateRating(aggregateRating),
    "@id": id,
    ...rest
  };
  return /* @__PURE__ */ import_react26.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "brand"
  });
}
var brand_default = BrandJsonLd;

// src/jsonld/article.tsx
var import_react27 = __toESM(require("react"));
function ArticleJsonLd({
  type = "Article",
  keyOverride,
  url,
  title,
  images,
  datePublished,
  dateModified,
  authorName,
  publisherName = void 0,
  publisherLogo = void 0,
  description
}) {
  const data = {
    datePublished,
    description,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url
    },
    headline: title,
    image: images,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo)
  };
  return /* @__PURE__ */ import_react27.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "article"
  });
}
var article_default = ArticleJsonLd;

// src/jsonld/webPage.tsx
var import_react28 = __toESM(require("react"));

// src/utils/schema/setReviewedBy.ts
function setReviewedBy(reviewedBy) {
  if (reviewedBy) {
    return {
      "@type": (reviewedBy == null ? void 0 : reviewedBy.type) || "Organization",
      ...reviewedBy
    };
  }
  return void 0;
}

// src/jsonld/webPage.tsx
function WebPageJsonLd({ keyOverride, reviewedBy, ...rest }) {
  const data = {
    ...rest,
    reviewedBy: setReviewedBy(reviewedBy)
  };
  return /* @__PURE__ */ import_react28.default.createElement(JsonLd, {
    keyOverride,
    ...data,
    type: "WebPage",
    scriptKey: "WebPage"
  });
}
var webPage_default = WebPageJsonLd;

// src/jsonld/socialProfile.tsx
var import_react29 = __toESM(require("react"));
function SocialProfileJsonLd({
  type,
  keyOverride,
  ...rest
}) {
  return /* @__PURE__ */ import_react29.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...rest,
    scriptKey: "social"
  });
}
var socialProfile_default = SocialProfileJsonLd;

// src/jsonld/howTo.tsx
var import_react30 = __toESM(require("react"));

// src/utils/schema/setCost.ts
function setCost(cost) {
  if (cost) {
    return {
      ...cost,
      "@type": "MonetaryAmount"
    };
  }
  return void 0;
}

// src/utils/schema/setSupply.ts
function setSupply(supply) {
  if (supply) {
    return supply.map((supplyItem) => ({
      "@type": "HowToSupply",
      name: supplyItem
    }));
  }
  return void 0;
}

// src/utils/schema/setTool.ts
function setTool(tool) {
  if (tool) {
    return tool.map((toolItem) => ({
      "@type": "HowToTool",
      name: toolItem
    }));
  }
  return void 0;
}

// src/utils/schema/setStep.ts
function setStep(step) {
  if (step) {
    return step.map((stepElement) => {
      const { itemListElement, image } = stepElement;
      const currentListElements = itemListElement == null ? void 0 : itemListElement.map(({ type, text }) => ({
        "@type": type,
        text
      }));
      return {
        ...stepElement,
        "@type": "HowToStep",
        itemListElement: currentListElements,
        image: setImage(image)
      };
    });
  }
  return void 0;
}

// src/jsonld/howTo.tsx
function howToJsonLd({
  type = "HowTo",
  keyOverride,
  image,
  estimatedCost,
  supply,
  tool,
  step,
  ...rest
}) {
  const data = {
    ...rest,
    image: setImage(image),
    estimatedCost: setCost(estimatedCost),
    supply: setSupply(supply),
    tool: setTool(tool),
    step: setStep(step)
  };
  return /* @__PURE__ */ import_react30.default.createElement(JsonLd, {
    type,
    keyOverride,
    ...data,
    scriptKey: "howTo"
  });
}
var howTo_default = howToJsonLd;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ArticleJsonLd,
  BrandJsonLd,
  BreadcrumbJsonLd,
  CarouselJsonLd,
  CollectionPageJsonLd,
  CorporateContactJsonLd,
  CourseJsonLd,
  DatasetJsonLd,
  DefaultSeo,
  EventJsonLd,
  FAQPageJsonLd,
  HowToJsonLd,
  JobPostingJsonLd,
  LocalBusinessJsonLd,
  LogoJsonLd,
  NewsArticleJsonLd,
  NextSeo,
  OrganizationJsonLd,
  ProductJsonLd,
  ProfilePageJsonLd,
  QAPageJsonLd,
  RecipeJsonLd,
  SiteLinksSearchBoxJsonLd,
  SocialProfileJsonLd,
  SoftwareAppJsonLd,
  VideoGameJsonLd,
  VideoJsonLd,
  WebPageJsonLd
});
//# sourceMappingURL=index.js.map